import { ContentModals, ContentModalStateType, useModalContext } from 'utils/contexts/modal';
import { UrlInputIconButton } from './UrlInputIconButton';
import { Image16 } from 'ui/icons';
import { useTranslations } from '../../hooks/useTranslations';
import { Asset, PanelIntent, PanelView } from 'modules/creativeLibrary';

export const DATA_TEST_ID = 'cl-icon-button';

/** used in url input field */
export const CreativeLibraryIconButton = ({
  onSelect,
  url,
}: {
  onSelect: (url: string) => void;
  url?: string;
}) => {
  const { showModal } = useModalContext<ContentModalStateType>();
  const { t } = useTranslations();
  const onClick = () => {
    showModal({
      initView: !!url ? PanelView.Detail : PanelView.List,
      intent: !!url ? PanelIntent.EditSelect : PanelIntent.Select,
      modal: ContentModals.CreativeLibrary,
      // for now we are only able to pass url property
      selectedAssetData: url ? ({ url } as Asset) : undefined,
      onSelect,
    });
  };

  return (
    <UrlInputIconButton
      data-test={DATA_TEST_ID}
      Icon={<Image16 height={20} width={20} isColorInherited />}
      tooltipContent={t('tooltip.insertImage')}
      onClick={onClick}
    />
  );
};
